<template>
    <v-main class="pt-0">
        <v-layout>
            <v-flex xs12 sm8 offset-sm2>
            <v-card class="rounded-xl my-5">
                <!-- <MainImage /> -->
                <v-card-text>
                    <div>
                        <!-- <hr> -->
                        <br>
                        <div class="text-lg-h5 text-center font-weight-bold">Solving your Durable Medical Equipment Compliance</div>
                        <br>
                        <div class="subheader">
                            <p>Compliance = Audit Success</p>
                            <p>Compliance = Payment Success</p>
                        </div>
                        <p id="problem">The problematic complexity of the medical clinic</p>
                        <p>In this ever-changing world, the medical profession is constantly being challenged to stay abreast with the newest technology and treatments for patient care. In addition to that requirement, the medical professionals must comply with complex documentation to get paid for their services and protect patient data. Medicare, Medicaid and other insurance providers continually update and change their requirements for payment. There are strict guidelines for medical professionals to follow regarding patient’s data, such as The Health Insurance Portability and Accountability Act (HIPAA), Stark Law and individual state regulations. The resulting problem is a plethora of paperwork and forms.</p>
                        <p id = 'solution'>Solution</p>
                        <p>National DME Compliance Software is designed to automate the adherence to these guidelines and free up more time for the medical professionals to provide care for their patients.</p>
                    </div>
                </v-card-text>
            </v-card>
            </v-flex>
        </v-layout>
    </v-main>
</template>

<script>
// import MainImage from './MainImage'

export default {
    name: 'MainBody',
    // components: {
    //     MainImage
    // }
}
</script>

<style>
    .v-card__text, .v-card__title {
        word-break: normal;
        text-align: left;
    }

    .subheader {
        display: flex;
        justify-content: space-around;
        font-weight: bold;
    }
/* 
    h1 {
        text-align: center;
    } */

    #problem, #solution {
        text-align: center;
        font-weight: bold;
    }
</style>